export var ShellMessageType;
(function (ShellMessageType) {
    ShellMessageType["PLUGIN_INVOCATION"] = "plugin-invocation";
    ShellMessageType["PLUGIN_RESULT"] = "plugin-result";
    ShellMessageType["EVENT"] = "event";
})(ShellMessageType || (ShellMessageType = {}));
//# sourceMappingURL=index.js.map